import { Component, OnInit } from '@angular/core';
import { NavParams, PopoverController } from '@ionic/angular';
import { LoadingService } from 'src/app/services/loading.service';
import { OrderOutputDto } from 'src/generated_client';

@Component({
  selector: 'app-popover-order-confirm',
  templateUrl: './popover-order-confirm.component.html',
  styleUrls: ['./popover-order-confirm.component.scss'],
})

export class PopoverOrderConfirmComponent implements OnInit {

  order: OrderOutputDto;
  timeSelected: number;
  time: number;

  constructor(
    private navParams: NavParams,
    private popoverController: PopoverController,
    public loading: LoadingService
  ) { }

  async ngOnInit() {
    this.order = this.navParams.get('order');
  }

  async orderConfirm() {
    await this.dismiss(false);
  }

  async dismiss(isCancel = true) {

    await this.popoverController.dismiss({
      optionSelected: isCancel ? null : this.timeSelected
    });
  }
}
